<template>
  <div class="view">
    <div class="mobantop">
      <div class="title1">选择表单模版</div>
      <div class="tabs">
        <div
          v-for="(item,index) in tabs1"
          :key="index"
          :class="tabidx==index?'on':''"
          class="item"
          @click="swithchtab(index)"
        >{{item}}</div>
      </div>
      <el-button type="primary" round size="small" style="width:90px" @click="yulan">预览</el-button>
      <el-button type="primary" round size="small" style="width:90px" @click="save">保存</el-button>
    </div>
    <el-container v-if="tabidx==0" class="basebigcon">
      <el-main>
        <div class="baseleftcon">
          <div class="baseleftbox formdesign formbigbox" style="height: auto">
            <div class="control-title"><p>{{formdata.title}}</p><img src="/static/img/menu.png" /></div>
            <div class="design-phone">
              <div class="design-scroll">
                <div class="design-body">
                  <div class="design-banner" v-if="headidx!==-1">
                    <img :src="formdata.back_img" alt />
                    <div class="design-banner-txt" v-if="formdata.title_show==1">{{formdata.title}}</div>
                  </div>                
                  <div class="design_edit">
                    <div
                      class="design_item"
                      v-for="(item,index) in designviews"
                      :key="index"
                      @click.stop="choosedesign(item,index)"
                      :draggable="item.draggable"
                    >
                      <div class="design_tool">
                        <component v-bind:is="item.template" :property="item.content"></component>
                      </div>
                    </div>
                  </div>
                  <div class="formsubmit">
                    <div class="btn1">提交</div>
                  </div>                
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <el-aside width="520px" style="height: 931px; overflow-y: auto">
        <div class="basiccon">
          <div class="title1">基本信息</div>
          <el-row>
            <el-col :span="4" class="title2">表单名称</el-col>
            <el-col :span="20">
              <el-input v-model="formdata.title" maxlength="10" show-word-limit></el-input>
              <div class="radio1">
                <el-radio-group v-model="formdata.title_show">
                  <el-radio :label="1">显示</el-radio>
                  <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="title2">表单描述</el-col>
            <el-col :span="20">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="formdata.describe"
                maxlength="1000"
                show-word-limit
              ></el-input>
            </el-col>
          </el-row>
          <div class="title1" style="margin:36px 0 32px;">样式设置</div>
          <el-row>
            <el-col :span="4" class="title2" style="text-align:right;padding-right:16px;">主题图</el-col>
            <el-col :span="20">
              <div class="imgbox1">
                <el-upload
                  class="upheadimg"
                  :action="actionUrl"
                  :data="data_"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  v-if="headidx==-1"
                >
                  <img v-if="upheadimg" :src="upheadimg" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="upload-preview" v-else>
                  <div class="upload-op">
                    <i class="el-icon-view" @click="preimgshow=true"></i>
                    <i class="el-icon-delete" @click="delpreimg"></i>
                  </div>
                  <img :src="formdata.back_img" alt class="img1" />
                </div>
                <p>最佳尺寸750X400像素</p>
              </div>
            </el-col>
          </el-row>
          <div class="title2" style="margin-top:26px;margin-left:13px;line-height:20px">样式</div>
          <div class="imgbox2">
            <div class="item" :class="headidx==-1?'on':''" @click="morenhead">默认</div>
            <div
              class="item"
              v-for="(item,index) in headimg"
              :key="index"
              @click="headimgtap(item.url,index)"
              :class="headidx==index?'on':''"
            >
              <img :src="item.url" />
            </div>
          </div>
        </div>
      </el-aside>
    </el-container>
    <div class="containerDesign" v-if="tabidx==1">
      <div class="applet_design formdesign" style="margin-bottom:0;height:850px">
        <div class="applet_tool">
          <div class="applet_tool_title">基础组件</div>
          <ul class="com_list">
            <li class="com_item" @click="gettool('add', 1)">
              <i class="iconfont iconbiaoti"></i>
              <span>单行文本</span>
            </li>
            <li class="com_item" @click="gettool('add', 2)">
              <i class="iconfont iconwenben"></i>
              <span>多行文本</span>
            </li>
            <li class="com_item" @click="gettool('add', 3)">
              <i class="el-icon-menu"></i>
              <span>标题</span>
            </li>
            <li class="com_item" @click="gettool('add', 4)">
              <i class="el-icon-time"></i>
              <span>时间</span>
            </li>
            <li class="com_item" @click="gettool('add', 5)">
              <i class="el-icon-date"></i>
              <span>日期</span>
            </li>
            <li class="com_item" @click="gettool('add', 6)">
              <i class="iconfont icontuwen"></i>
              <span>下拉框</span>
            </li>
            <li class="com_item" @click="gettool('add', 7)">
              <i class="danxuanicon"></i>
              <span>单项选择</span>
            </li>
            <li class="com_item" @click="gettool('add', 8)">
              <i class="duoxuanicon"></i>
              <span>多项选择</span>
            </li>
            <li class="com_item" @click="gettool('add', 9)">
              <i class="el-icon-picture-outline"></i>
              <span>上传图片</span>
            </li>
            <li class="com_item" @click="gettool('add', 10)">
              <i class="el-icon-location-information"></i>
              <span>选择省市区</span>
            </li>
            <li class="com_item" @click="gettool('add', 11)">
              <i class="el-icon-location-outline"></i>
              <span>占位符</span>
            </li>
          </ul>
        </div>
        <div class="applet_preview" @click="hideDesign()">
          <div class="design_preview formbigbox" style="height: 790px">
            <div class="control-title"><p>{{formdata.title}}</p><img src="/static/img/menu.png" /></div>
            <div class="design-phone">
              <div class="design-scroll">
                <div class="design-body">
                  <div class="design-banner" v-if="headidx!==-1">
                    <img :src="formdata.back_img" alt />
                    <div class="design-banner-txt" v-if="formdata.title_show==1">{{formdata.title}}</div>
                  </div>               
                  <div class="design_edit">
                    <!--                    @dragstart="handleDragStart($event, item)"-->
                    <!--                    @dragover.prevent="handleDragOver($event, item)"-->
                    <!--                    @dragenter="handleDragEnter($event, item)"-->
                    <!--                    @dragend="handleDragEnd($event, item)"-->
                    <draggable
                      v-model="designviews"
                      :options="{draggable:'.design_item',animation: 150}"
                      :move="getdata"
                      @update="datadragEnd"
                    >
                      <transition-group>
                        <div
                          class="design_item"
                          :class="currentindex==index?'on':''"
                          v-for="(item,index) in designviews"
                          :key="index"
                          @click.stop="choosedesign(item,index)"
                          :draggable="item.draggable"
                        >
                          <div class="design_mask" v-if="index!==currentindex && showall == 1"></div>
                          <div class="design_oper design_oper2" >
                            <ul>
                              <li v-if="index!==0">
                                <i class="el-icon-caret-top" @click.stop="lineNumber(0, index, item)"></i>
                              </li>
                              <li v-if="designviews.length-1!==index">
                                <i
                                  class="el-icon-caret-bottom"
                                  @click.stop="lineNumber(1, index, item)"
                                ></i>
                              </li>
                              <li>
                                <i class="el-icon-close" @click="designdel(index)"></i>
                              </li>
                            </ul>
                          </div>
                          <div class="design_tool">
                            <component v-bind:is="item.template" :property="item.content"></component>
                          </div>
                        </div>
                      </transition-group>
                    </draggable>
                  </div>
                  <div class="formsubmit">
                    <div class="btn1">提交</div>
                  </div>
                </div>  
              </div>            
            </div>
          </div>
        </div>
        <div class="applet_params" v-if="currentview!==-1">
          <component
            v-if="currentview"
            v-bind:is="currentview.propertytype"
            :property.sync="currentview.content"
          ></component>
        </div>
      </div>
    </div>
    <el-container v-if="tabidx==2" class="sharebigcon">
      <el-main>
        <div class="shareleftcon">
          <div class="shareleftbox">
            <div class="title1">海报分享效果预览</div>
            <div class="shareleft1">
              <div class="sl1-1">
                <div class="sl1-1txt">
                  方小卡
                  <br />2019.12.23分享这份表单给你
                </div>
                <img :src="imgUrl1"  class="head1">
              </div>
              <div class="sl1box">
                <div class="sl1-2">
                  <div class="sl1-2noimg" v-if="shareidx==-1">请在右侧增加分享图</div>
                  <img :src="formdata.share_img" alt v-else />
                  <p>{{formdata.share_title}}</p>
                </div>
                <div class="sl1-3">
                  <img :src="imgUrl2" class="codeimg" />
                  <div class="sl1-3txt">
                    长按小程序码<br>查看表单
                  </div>
                </div>
              </div>
            </div>
            <div class="title1">小程序分享效果预览</div>
            <div class="shareleft2">
              <img :src="imgUrl1"  class="head2">
              <div class="sl2box">
                <div class="sl2-1">
                  <img :src="imgUrl1"  class="head1">
                  <div class="sl2-1txt">
                    方小卡
                    <br />2019.12.23给你分享这份表单
                  </div>
                </div>
                <div class="sl2-2">
                  <div class="sl2-2noimg" v-if="shareidx==-1">请在右侧增加分享图</div>
                  <img :src="formdata.share_img" alt v-else />
                  <p>{{formdata.share_describe}}</p>
                </div>
                <div class="sl2-3">
                  <img :src="imgUrl2" class="codeimg" />
                  <div class="sl2-3txt">
                    长按小程序码<br>查看表单
                  </div>
                </div>
              </div>
            </div>
            <div class="title1">微信朋友圈分享效果预览</div>
            <div class="shareleft3">
              <img :src="imgUrl1"  class="head2">
              <div class="sl3right">
                <div class="sl3-1">方小卡</div>
                <div class="sl3-2">
                  <div class="sl3-2noimg" v-if="shareidx==-1"></div>
                  <img :src="formdata.share_img" alt v-else />
                  <div class="sl3-2txt">{{formdata.share_title}}</div>
                </div>
                <div class="sl3-3">
                  <div class="lefttip">1分钟前</div>
                  <div class="righttip">··</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <el-aside width="520px">
        <div class="basiccon sharecon">
          <div class="title1">分享设置</div>
          <el-row>
            <el-col :span="4" class="title2">表单名称</el-col>
            <el-col :span="20">
              <el-input v-model="formdata.share_title" placeholder show-word-limit maxlength="20"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="title2">表单描述</el-col>
            <el-col :span="20">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="formdata.share_describe"
                maxlength="36"
                show-word-limit
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="title2" style="text-align:right;padding-right:16px;">分享图片</el-col>
            <el-col :span="20">
              <div class="imgbox1 shareimgbox1">
                <el-upload
                  class="upheadimg"
                  :action="actionUrl"
                  :data="data_"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess1"
                  :before-upload="beforeAvatarUpload1"
                  v-if="shareidx==-1"
                >
                  <img v-if="upshareimg" :src="upshareimg" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="upload-preview" v-else>
                  <div class="upload-op">
                    <i class="el-icon-view" @click="preimgshow2=true"></i>
                    <i class="el-icon-delete" @click="delpreimg2"></i>
                  </div>
                  <img :src="formdata.share_img" alt class="img1" />
                </div>
                <p>最佳尺寸750X495像素</p>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" class="title2" style="text-align:right;padding-right:16px;">其他</el-col>
            <el-col :span="20">
              <div class="shareimgbox2">
                <div class="item" :class="shareidx==-1?'on':''" @click="morenshare">默认</div>
                <div
                  class="item"
                  v-for="(item,index) in shareimg"
                  :key="index"
                  @click="shareimgtap(item.url,index)"
                  :class="shareidx==index?'on':''"
                >
                  <img :src="item.url" />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-aside>
    </el-container>
    <el-dialog title="预览图片" :visible.sync="preimgshow" width="25%" :before-close="handleClose">
      <img :src="formdata.back_img" style="max-width: 100%" />
    </el-dialog>
    <el-dialog title="预览图片" :visible.sync="preimgshow2" width="25%" :before-close="handleClose2">
      <img :src="formdata.share_img" style="max-width: 100%" />
    </el-dialog>
    <el-dialog title="预览" :visible.sync="preimgshow3" width="25%" :before-close="handleClose3">
        <div class="precode">
        <div class="pretitle">{{formdata.title}}</div>
        <img :src="h5code" style="max-width: 100%" />
        <div class="pretxt">扫一扫预览效果</div>
        <el-button type="primary" @click="preimgshow3=false">使用该模版</el-button> 
</div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import applettop from "@/components/applettop.vue";
import companytool from "@/components/formtools/company.vue";
import companyProperty from "@/components/formtools/companyProperty.vue";
import teamtool from "@/components/formtools/team.vue";
import teamProperty from "@/components/formtools/teamProperty.vue";
import cooperationtool from "@/components/formtools/cooperation.vue";
import cooperationProperty from "@/components/formtools/cooperationProperty.vue";
import myCarttool from "@/components/formtools/myCart.vue";
import myCartProperty from "@/components/formtools/myCartProperty.vue";
import vrCompany from "@/components/formtools/vrCompany.vue";
import vrCompanyProperty from "@/components/formtools/vrCompanyProperty.vue";
import companyInformationtool from "@/components/formtools/companyInformation.vue";
import companyInformationProperty from "@/components/formtools/companyInformationProperty.vue";
import recruitCompanytool from "@/components/formtools/recruitCompany.vue";
import recruitCompanyProperty from "@/components/formtools/recruitCompanyProperty.vue";
import contactUstool from "@/components/formtools/contactUs.vue";
import contactUsProperty from "@/components/formtools/contactUsProperty.vue";
import producttool from "@/components/formtools/product.vue";
import productProperty from "@/components/formtools/productProperty.vue";
import titletool from "@/components/formtools/title.vue"; // 标题
import texttool from "@/components/formtools/text.vue"; // 标题
import textProperty from "@/components/formtools/textProperty.vue"; // 标题
import textimgtool from "@/components/formtools/textimg.vue"; // 标题
import textimgProperty from "@/components/formtools/textimgProperty.vue"; // 标题
import imgtool from "@/components/formtools/img.vue"; // 标题
import imgProperty from "@/components/formtools/imgProperty.vue"; // 标题
import videotool from "@/components/formtools/video.vue"; // 视频
import videoProperty from "@/components/formtools/videoProperty.vue"; // 视频
import titleProperty from "@/components/formtools/titleProperty.vue"; // 标题栏设置
import captions from "@/components/formtools/captions.vue"; // 文字说明
import captionsProperty from "@/components/formtools/captionsProperty.vue"; // 文字说明设置
import datetool from "@/components/formtools/date.vue"; // 日期
import dateProperty from "@/components/formtools/dateProperty.vue";
import multiCheck from "@/components/formtools/multiCheck.vue";
import multiCheckProperty from "@/components/formtools/multiCheckProperty.vue";
import multiText from "@/components/formtools/multiText.vue";
import multiTextProperty from "@/components/formtools/multiTextProperty.vue";
import selecttool from "@/components/formtools/select.vue";
import selectProperty from "@/components/formtools/selectProperty.vue";
import selectProvinces from "@/components/formtools/selectProvinces.vue";
import selectProvincesProperty from "@/components/formtools/selectProvincesProperty.vue";
import singleCheck from "@/components/formtools/singleCheck.vue";
import singleCheckProperty from "@/components/formtools/singleCheckProperty.vue";
import singleText from "@/components/formtools/singleText.vue";
import singleTextProperty from "@/components/formtools/singleTextProperty.vue";
import timetool from "@/components/formtools/time.vue";
import timeProperty from "@/components/formtools/timeProperty.vue";
import uploadtool from "@/components/formtools/upload.vue";
import uploadProperty from "@/components/formtools/uploadProperty.vue";
import rotarySowing from "@/components/formtools/rotarySowing.vue";
import rotarySowingProperty from "@/components/formtools/rotarySowingProperty.vue";
import seatline from "@/components/formtools/seatline.vue";
import formtitle from "@/components/formtools/formtitle.vue";
import formtitleProperty from "@/components/formtools/formtitleProperty.vue";
import placeholder from "@/components/formtools/placeholder.vue";
import placeholderProperty from "@/components/formtools/placeholderProperty.vue";
import { yeartime } from "@/assets/js/common";
import { pagination } from "@/util/util.js";
import api from "@/api.js";
export default {
  name: "formEdit",
  components: {
    placeholder,
    placeholderProperty,
    formtitle,
    formtitleProperty,
    multiText,
    multiTextProperty,
    draggable,
    companytool,
    companyProperty,
    producttool,
    productProperty,
    companyInformationtool,
    companyInformationProperty,
    contactUstool,
    contactUsProperty,
    applettop,
    titletool,
    texttool,
    textProperty,
    textimgtool,
    textimgProperty,
    imgtool,
    imgProperty,
    videotool,
    videoProperty,
    titleProperty,
    captions,
    captionsProperty,
    datetool,
    dateProperty,
    multiCheck,
    multiCheckProperty,
    multiText,
    multiTextProperty,
    selecttool,
    selectProperty,
    selectProvinces,
    selectProvincesProperty,
    singleCheck,
    singleCheckProperty,
    singleText,
    singleTextProperty,
    timetool,
    timeProperty,
    uploadtool,
    uploadProperty,
    rotarySowing,
    rotarySowingProperty,
    seatline,
    teamtool,
    teamProperty,
    cooperationtool,
    cooperationProperty,
    myCarttool,
    myCartProperty,
    recruitCompanytool,
    recruitCompanyProperty,
    vrCompany,
    vrCompanyProperty
  },
  data() {
    return {
      actionUrl: api.uploadTokenImg,
      imgUrl1:require("../../assets/imgs/share1.png"),
      imgUrl2:require("../../assets/imgs/share2.png"),
      data_: { token: sessionStorage.getItem("token") },
      flag: true,
      currentindex: -1,
      currentview: null,
      designviews: [],
      preimgshow: false,
      preimgshow2: false,
      preimgshow3: false,
      dragging: null,
      curHeight: null,
      curBoxHeight: null,
      showall: 1, // 0 全部 1 单个
      tabidx: 0,
      tabs1: ["基本样式", "页面内容", "分享设置"],
      formdata: {},
      headimg: [],
      shareimg: [],
      upheadimg: "",
      upshareimg: "",
      headidx: -1,
      shareidx: -1,
      h5code:""
    };
  },
  created() {
    document.body.ondrop = function(event) {
      event.preventDefault();
      event.stopPropagation();
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中…",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.4)",
      customClass: "fontColor"
    });
    if (this.$route.query.id) {
      this.headidx = -2;
      this.shareidx = -2;
    }
    this.InitFn1(loading);
  },
  methods: {
    InitFn1(loading) {
      // 创建执行
      this.axios
        .post(api.companyadmin_form_detail, {
          form_id: this.$route.query.id
        })
        .then(response => {
          if (response.data.code == 0) {
            this.formdata = response.data.info;
            if(response.data.info.back_img==""){
              this.headidx=-1
            }
            if(response.data.info.share_img==""){
              this.shareidx=-1
            }
            let list_line = response.data.info.page_content;
            if (list_line.length !== 0) {
              for (let i in list_line) {
                this.gettool("edit", list_line[i].type, list_line[i].content);
              }
              this.showall = 0;
              // this.currentindex = 0;
              this.designviews[0].draggable = true; // 显示
              this.currentview = this.designviews[0];
            } else {
              this.designviews = [];
              this.currentview = null;
            }
          } else {
          }
        })
        .catch(() => {});
      this.axios
        .post(api.companyadmin_form_headimg, {})
        .then(response => {
          if (response.data.code == 0) {
            this.headimg = response.data.list;
          } else {
          }
        })
        .catch(() => {});
      this.axios
        .post(api.companyadmin_form_shareimg, {})
        .then(response => {
          if (response.data.code == 0) {
            this.shareimg = response.data.list;
            loading.close();
          } else {
          }
        })
        .catch(() => {});
    },
    handleClose() {
      this.preimgshow = false;
    },
    delpreimg() {
      this.formdata.back_img = "";
      this.headidx = -1;
      this.upheadimg = "";
    },
    handleClose2() {
      this.preimgshow2 = false;
    },
    delpreimg2() {
      this.formdata.share_img = "";
      this.shareidx = -1;
      this.upshareimg = "";
    },
    yulan(){
      let data_ = [];
      for (let i in this.designviews) {
        let obj_ = {};
        obj_.type = this.designviews[i].type;
        obj_.content = this.designviews[i].content;
        data_.push(obj_);
      }
      this.formdata.page_content = JSON.stringify(data_);
      if(this.formdata.title==""){
        this.$message({
        message: "请输入表单名称!",
        type: "warning"
      });
      }else{
      this.axios
          .post(api.companyadmin_form_preview, this.formdata)
          .then(response => {
            if (response.data.code == 0) {
                this.preimgshow3=true
                this.h5code=response.data.info.h5code1
            } else {
            }
          })
          .catch(() => {});
      }
    
      
    },
     handleClose3() {
      this.preimgshow3 = false;
    },
    handleAvatarSuccess(res, file) {
      // this.form.pic = URL.createObjectURL(file.raw);
      if (res.code === 0) {
        this.upheadimg = res.path;
        this.formdata.back_img = res.path;
        this.headidx = -2;
        this.$message({
          message: "上传成功",
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return isLt2M;
    },
    handleAvatarSuccess1(res, file) {
      if (res.code === 0) {
        this.upshareimg = res.path;
        this.formdata.share_img = res.path;
        this.shareidx = -2;
        this.$message({
          message: "上传成功",
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    beforeAvatarUpload1(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return isLt2M;
    },
    swithchtab(e) {
      if (e > 0 && !this.formdata.title) {
        this.$message.warning('请填写表单名称');
        return
      }
      this.tabidx = e;
    },
    headimgtap(url, index) {
      this.formdata.back_img = url;
      this.headidx = index;
    },
    morenhead() {
      this.headidx = -1;
      this.formdata.back_img = "";
      this.upheadimg = "";
    },
    shareimgtap(url, index) {
      this.formdata.share_img = url;
      this.shareidx = index;
    },
    morenshare() {
      this.shareidx = -1;
      this.formdata.share_img = "";
      this.upshareimg = "";
    },
    changeInit() {
      this.InitFn();
    },
    save() {
      if (!this.formdata.title) {
        this.$message.warning('请填写表单名称');
        this.tabidx = 0;
        return
      }
      if (this.designviews.length === 0) {
        this.$message.warning('请编辑相应的内容！');
        return;
      }
      let data_ = [];
      for (let i in this.designviews) {
        let obj_ = {};
        obj_.type = this.designviews[i].type;
        obj_.content = this.designviews[i].content;
        data_.push(obj_);
      }
      this.formdata.page_content = JSON.stringify(data_);
        this.axios
          .post(api.companyadmin_form_edit, this.formdata)
          .then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: "保存成功正在跳转",
              });
              this.$router.push({ name: "form" });
            } else {
            }
          })
          .catch(() => {});
    },

    gettool(type, typeNumber, option) {
      // type add 添加 edit 编辑 option编辑的内容
      let currentview = null;
      switch (typeNumber) {
        case 1: // 单行文本
          currentview = this.getline1(type, option);
          break;
        case 2: // 多行文本
          currentview = this.getline2(type, option);
          break;
        case 3: // 标题
          currentview = this.gettitle(type, option);
          break;
        case 4: // 时间
          currentview = this.gettime(type, option);
          break;
        case 5: //日期
          currentview = this.getdate(type, option);
          break;
        case 6: // 下拉框
          currentview = this.getselect(type, option);
          break;
        case 7: // 单项选择
          currentview = this.getcheck1(type, option);
          break;
        case 8: // 多项选择
          currentview = this.getcheck2(type, option);
          break;
        case 9: // 上传图片
          currentview = this.getimg(type, option);
          break;
        case 10: //省市区
          currentview = this.getpro(type, option);
          break;
        case 11: // 占位符
          currentview = this.getplace(type, option);
          break;
      }
      for (let i in this.designviews) {
        if (this.designviews[i].draggable) {
          this.designviews[i].draggable = false;
        }
      }
      if (type === "add") {
        this.showall = 1;
        currentview.draggable = true; // 显示
        if (this.currentindex !== null) {
          this.designviews.splice(this.currentindex + 1, 0, currentview);
          this.currentindex = this.currentindex + 1;
          this.currentview = currentview;
        } else {
          this.designviews.push(currentview);
          this.currentindex = this.designviews.length - 1;
          this.currentview = currentview;
        }
      } else {
        this.designviews.push(currentview);
      }
    },
    //当行文本
    getline1(type, option) {
      let content_ = {
        type: 1,
        template: "singleText",
        propertytype: "singleTextProperty",
        content: {
          name: "手机号",
          radio: 1,
          radio2: 2,
          num: 15,
          checked: true,
          value:"",
          vcode:""
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },

    //多行文本
    getline2(type, option) {
      let content_ = {
        type: 2,
        template: "multiText",
        propertytype: "multiTextProperty",
        content: {
          name: "多行文本",
          checked: false,
          num: 300,
          value:""
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 标题
    gettitle(type, option) {
      let content_ = {
        type: 3,
        template: "formtitle",
        propertytype: "formtitleProperty",
        content: {
          title: "标题栏"
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    //时间
    gettime(type, option) {
      let content_ = {
        type: 4,
        template: "timetool",
        propertytype: "timeProperty",
        content: {
          name: "时间",
          value:""
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 日期
    getdate(type, option) {
      let content_ = {
        type: 5,
        template: "datetool", // 类型
        propertytype: "dateProperty",
        content: {
          name: "日期",
          value:""
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 下拉框
    getselect(type, option) {
      let content_ = {
        type: 6,
        template: "selecttool", // 类型
        propertytype: "selectProperty",
        content: {
          name: "下拉框",
          list: [
            { label: "选项一", disabled: false, value: "1",checked:false},
            { label: "选项二", disabled: false, value: "2",checked:false}
          ],
          checked: false,
          value:""
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 单项选择
    getcheck1(type, option) {
      let content_ = {
        type: 7,
        template: "singleCheck", // 类型
        propertytype: "singleCheckProperty",
        content: {
          radio: 1,
          name1:"性别",
          name2: "自定义",
           list2: [
            { label: "男", disabled: false, value: "1",checked:false},
            { label: "女", disabled: false, value: "2",checked:false},
             { label: "保密", disabled: false, value: "3",checked:false}
          ],
          list: [
            { label: "选项一", disabled: false, value: "1",checked:false},
            { label: "选项二", disabled: false, value: "2",checked:false}
          ],
          checked: false
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 多项选择
    getcheck2(type, option) {
      let content_ = {
        type: 8,
        template: "multiCheck", // 类型
        propertytype: "multiCheckProperty",
        content: {
          name: "多项选择",
          list: [
           { label: "选项一", disabled: false, value: 1,checked:false},
            { label: "选项二", disabled: false, value: 2,checked:false}
          ],
          checked: false
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 选择省市区
    getimg(type, option) {
      let content_ = {
        type: 9,
        template: "uploadtool", // 类型
        propertytype: "uploadProperty",
        content: {
          name: "上传图片",
          num: 4,
          checked: false,
          imgs:[]
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 选择省市区
    getpro(type, option) {
      let content_ = {
        type: 10,
        template: "selectProvinces", // 类型
        propertytype: "selectProvincesProperty",
        content: {
          name: "地区",
          radio: 1,
          checked: false,
          area:"",
          address:""
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    getplace(type, option) {
      let content_ = {
        type: 11,
        template: "placeholder", // 类型
        propertytype: "placeholderProperty",
        content: {
          height: 30,
          radio: 1
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 点击当前项
    choosedesign(item, index) {
      this.showall = 1;
      this.currentview = item;
      this.currentindex = index;
    },
    // 移动当前选项
    lineNumber(option, index, item) {
      // option 0 上 1 下
      if (this.flag) {
        this.flag = false;
        // designviews
        const newItems = [...this.designviews];
        let index_Line = index + 1;
        if (Number(option) === 0) {
          index_Line = index - 1;
        }
        newItems.splice(index_Line, 0, ...newItems.splice(index, 1));
        for (let i in newItems) {
          newItems[i].draggable = Number(i) === index_Line ? true : false;
        }
        this.currentindex = index_Line;
        this.designviews = newItems;
        setTimeout(() => {
          this.flag = true;
        }, 300);
      }
    },
    // 删除
    designdel(index) {
      // this.designviews[index-1]
      let self_ = this;

      this.$confirm("确认要删除模版模块?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        closeOnClickModal: false
      })
        .then(() => {
          self_.currentview = this.designviews[index - 1];
          self_.currentindex = index - 1;
          self_.designviews.splice(index, 1);
        })
        .catch(() => {});
    },
    getdata(data) {},
    datadragEnd(evt) {
      this.currentindex = evt.newIndex;
    },
    onSubmit() {},
    // 传递数据
    getMsgFormSon(data) {},
    hideDesign() {
      this.showall = 0;
      this.currentindex = null;
    }
  }
};
</script>
<style>
.homeHeight {
  display: none;
}
</style>
